import React from 'react'
import { Heading } from '@myxplor/ui'

const Empty = () => <Heading small>No CCS Service Registrations</Heading>

export default Empty



// WEBPACK FOOTER //
// ./src/gov-registrations/details/ccs-registrations/views/empty.jsx